package com.techspiration.webuserapp

/**
 * webUserApp'in route'ları — `core:navigation`'daki `NavKey`/`Navigator` deseniyle AYNI fikir
 * (adlandırılmış route'lar arasında `goto` ile geçiş), ama `core:navigation` PAYLAŞILMAZ: o modülün
 * `NavDisplay`'i Compose UI'nin (Skia/canvas) render motoruna bağlıdır ve Compose HTML'in gerçek
 * DOM Applier'ıyla aynı composition içinde birleştirilemez.
 */
sealed interface UserRoute

data object HomeRoute : UserRoute
data object AboutRoute : UserRoute
data object PrivacyRoute : UserRoute
data object TermsRoute : UserRoute
data object LegalRoute : UserRoute

/** Route ↔ URL path eşlemesi — direkt link (ör. Apple review'ın tıkladığı link) doğru ekranı açsın diye. */
fun UserRoute.path(): String = when (this) {
    HomeRoute -> "/"
    AboutRoute -> "/about"
    PrivacyRoute -> "/privacy"
    TermsRoute -> "/terms"
    LegalRoute -> "/legal"
}

fun routeForPath(path: String): UserRoute = when (path.trimEnd('/').ifEmpty { "/" }) {
    "/about" -> AboutRoute
    "/privacy" -> PrivacyRoute
    "/terms" -> TermsRoute
    "/legal" -> LegalRoute
    else -> HomeRoute
}
